import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const getAll = async () => (
  axiosRequest({
    url: '/v1/dashboard/getAll',
    method: 'POST',
    headers: defaultHeaders,
  })
);

export {
  getAll,
};
